
/// <amd-module name="TFS/Admin/Common/Constants/TelemetryConstants" />
export namespace Area {
    export const Admin = "Admin";
}

export namespace Feature {
    export const ProjectOverview = "ProjectOverview";
    export const OrganizationPermissions = "OrganizationPermissions";
    export const OrganizationOverview = "OrganizationOverview";
    export const OrganizationProjects = "OrganizationProjects";
    export const OrganizationAad = "OrganizationAad";
    export const ProjectOverviewAdmins = "ProjectOverviewAdmins";
    export const ProfileAboutView = "ProfileAboutView";
    export const ProfilePreferences = "ProfilePreferences";
    export const ProfileTheme = "ProfileTheme";
    export const ProfileRefreshPermissions = "ProfileRefreshPermissions";
    export const GitHubConnection = "GitHubConnection";
    export const SSHPublicKeys = "SSHPublicKeys";
    export const Authorizations = "Authorizations";
    export const OrganizationGroups = "OrganizationGroups";
    export const ProjectPermissions = "ProjectPermissions";
    export const ProjectGroups = "ProjectGroups";
    export const SettingsPivot = "SettingsPivot";
    export const AdminDefault = "Admin";
    export const Teams = "Teams";
    export const ResourceSecurity = "ResourceSecurity";
    export const SettingsSearch = "SettingsSearch";
    export const OrganizationPolicies = "OrganizationPolicies";
    export const ProjectDashboards = "ProjectDashboards";
    export const ProfileOrganizations = "ProfileOrganizations";
}

export namespace ErrorMessageSearchString {
    export const AccessDenied = "Access Denied";
    export const UserNotAuthorized = "TF400813";
    export const UserNeedsSignIn = "TF401444";
    export const UserCouldNotBeAdded = "Could not add user";
    export const UpnPresent = "@";
    export const ActiveMemberNotAllowed = "Only active members";
    export const IdentityMaterializationFailure = "VS403283";
    export const AccountInsufficientPermission = "TF50309";
}

export namespace ErrorMessageReturnString {
    export const AccessDenied = "The current user does not have the required permissions to perform that action.";
    export const UserNotAuthorized = "The current user is not authorized to access this resource.";
    export const UserNeedsSignIn = "The user needs to sign in at least once to access this service.";
    export const UserCouldNotBeAdded = "Could not add user into tenant.";
    export const UpnPresent = "Error message contains email address. Please see ProductTrace.";
    export const ActiveMemberNotAllowed = "Only active members of the AAD tenant are allowed to perform the link.";
    export const IdentityMaterializationFailure = "Could not add user at this time.";
    export const AccountInsufficientPermission =
        "Account does not have sufficient permissions to complete the operation. More perrmissions are needed to perform this operation.";
}

export namespace TelemetryProperties {
    export const Action = "Action";
    export const SubFeature = "SubFeature";
    export const ErrorMessage = "ErrorMessage";
    export const PageUrl = "PageUrl";
}

export enum ResourceSecurityComponent {
    SecurityPanel,
    SecurityMembers,
    SecurityPermissions
}

export namespace PerformanceScenarios {
    export const LoadSecurityModel = "LoadSecurityModel";
    export const LoadMembersData = "LoadMembersData";
    export const LoadSecurityPermissionsData = "LoadSecurityPermissionsData";
}
